import __request__ from "routing/request";
export function saveConfig(config, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.llm/model-provider/config", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteConfig(requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.llm/model-provider/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/model-provider/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function providers(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/model-provider/providers", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listModels(provider, credentials, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.llm/model-provider/providers/${provider}/models`, credentials, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function test(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.llm/model-provider/test", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
